import packageInfo from '../../package.json';
export const version = packageInfo.version;
export const TOKEN_KEY = 'my-app-token';
export const USER_KEY = 'my-app-user';
export const ROLES_KEY = 'my-app-roles';
export const ROLE_SELECTED = 'RoleSelected';
export const PROJECT_SELECTED = 'ProjectSelected';
export const DATABASE_SELECTED = 'DatabaseSelected';
export const FAZENDA = 'fazenda';
